module.exports = __webpack_public_path__ + "static/img/30001 (1).2ca4fa5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30001 (1).webp
// module id = T5hE
// module chunks = 14